
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$tabs.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$tabs.js';
export default __default__;
